import { render, staticRenderFns } from "./select-field.vue?vue&type=template&id=e8dccad2&scoped=true&lang=pug"
import script from "./select-field.vue?vue&type=script&lang=js"
export * from "./select-field.vue?vue&type=script&lang=js"
import style0 from "./select-field.vue?vue&type=style&index=0&id=e8dccad2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dccad2",
  null
  
)

export default component.exports